<template>
    <div class="py-3">
        <div class="container">
            <TravelExpenseReportTabs :linksDisabled=false :expenseReportID=expenseReportID ref="nav"></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!loading && expenseReportStatusTypeId > 1" style="text-align:center; color:red;">Changes will not be saved unless Save button is clicked</div>
                    <h4 style="font-weight:900; margin-bottom:0px;">Meals <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner></h4>
                    <div class="my-1" style="margin-top:0px;">{{expenseReportStatusTypeName}}</div>
                    <ValidationAlertComponent v-if="!loading" :expenseReportID="expenseReportID" :area="'meals'"></ValidationAlertComponent>
                    <form v-if="!loading" class="" v-on:submit.prevent>
                        <div class="form-group">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Location</th>
                                        <th scope="col">Year</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="ms.domesticLocation" v-for="(ms,mSIndex) in mealSummary">
                                        <td><span v-if="ms.domesticLocation.city">{{ms.domesticLocation.city}},&nbsp;</span> <span v-if="ms.domesticLocation.state">{{ms.domesticLocation.state}}</span><span v-if="ms.domesticLocation.country">&nbsp;{{ms.domesticLocation.county}}</span></td>
                                        <td>{{ms.year}}</td>
                                        <td>{{ms.amount}}</td>
                                    </tr>
                                    <tr v-if="ms.foreignLocation" v-for="(ms,mSIndex) in mealSummary">
                                        <td><span v-if="ms.foreignLocation.city">{{ms.foreignLocation.city}},&nbsp;</span> <span v-if="ms.foreignLocation.country">{{ms.foreignLocation.country}}</span></td>
                                        <td>{{ms.year}}</td>
                                        <td>{{ms.amount}}</td>
                                    </tr>
                                    <tr v-if="ms.otherDomesticLocation" v-for="(ms,mSIndex) in mealSummary">
                                        <td><span v-if="ms.otherDomesticLocation.city">{{ms.otherDomesticLocation.city}},&nbsp;</span> <span v-if="ms.otherDomesticLocation.country">{{ms.otherDomesticLocation.country}}</span></td>
                                        <td>{{ms.year}}</td>
                                        <td>{{ms.amount}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style="overflow-x: auto;" class="mb-2">
                            <table v-if="meals.length" class="table">
                                <thead>
                                    <tr>
                                        <th scope="col" class="">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info btn-sm border-primary" @click="zeroOutAll(meals)">Zero All</button>
                                                <button type="button" class="total btn btn-info btn-sm border-primary" @click="autoPopulateAll()">Auto Populate</button>
                                            </div>
                                        </th>
                                        <th scope="col" v-for="(m,mIndex) in meals">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info btn-sm border-primary" @click="zeroOut(m)">Zero</button>
                                                <button type="button" class="btn btn-info btn-sm border-primary" @click="resetMealDayToReferenceValues(m)">Reset</button>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <thead v-if="auto_populated || mealsGrandTotal > 0">
                                    <tr>
                                        <th scope="col"> </th>
                                        <th scope="col" v-for="(m,mIndex) in meals" :key="m.date"><div class="personalText" v-bind:class="{'showPersonalText':m.personalDay}">personal day<br /></div>{{m.date  | formatDate}}</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody v-if="auto_populated || mealsGrandTotal > 0">
                                    <tr>
                                        <th scope="row">Breakfast</th>
                                        <td v-for="(m,mIndex) in meals" class="td-updated" v-bind:class="{'offday':m.personalDay}">
                                            <input class="remove-input-border" v-model="m.breakfast" v-bind:class="{'offday':m.personalDay, 'errortext': m.breakfastExceptions && m.breakfastExceptions.length }" @input="updateMealDay(m)" type="number" @focus="$event.target.select()" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Lunch</th>
                                        <td v-for="(m,mIndex) in meals" class="td-updated" v-bind:class="{'offday':m.personalDay}">
                                            <input class="remove-input-border" v-model="m.lunch" v-bind:class="{'offday':m.personalDay, 'errortext': m.lunchExceptions && m.lunchExceptions.length }" @input="updateMealDay(m)" type="number" @focus="$event.target.select()" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Dinner</th>
                                        <td v-for="(m,mIndex) in meals" class="td-updated" v-bind:class="{'offday':m.personalDay}">
                                            <input class="remove-input-border" v-model="m.dinner" v-bind:class="{'offday':m.personalDay, 'errortext': m.dinnerExceptions && m.dinnerExceptions.length }" @input="updateMealDay(m)" type="number" @focus="$event.target.select()" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Incidentals</th>
                                        <td v-for="(m,mIndex) in meals" class="td-updated" v-bind:class="{'offday':m.personalDay}">
                                            <input class="remove-input-border" v-model="m.incidentals" v-bind:class="{'offday':m.personalDay, 'errortext': m.incidentalsExceptions && m.incidentalsExceptions.length }" @input="updateMealDay(m)" type="number" @focus="$event.target.select()" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Total</th>
                                        <td class="td-updated" v-bind:class="{'offday':m.personalDay}" v-for="(m,mIndex) in meals">{{m.total | currency}}</td>
                                    </tr>
                                    <tr class="total">
                                        <th scope="row">Adjusted Total   <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Adjusted total reflects modifications you made to specific per diem values. First/Last days are adjusted for 75% rule.'" icon="info-circle" /> </th>
                                        <td class="td-updated" v-bind:class="{'offday':m.personalDay}" v-for="(m,mIndex) in meals">{{m.adjustedTotal | currency}}</td>
                                    </tr>
                                    <tr class="">
                                        <th scope="row"> <span style="font-weight:bold; margin-left:5px;">Grand Total</span></th>
                                        <td class="td-updated" style="outline:none; font-weight:bold;"> {{mealsGrandTotal | currency}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="list-group pb-2" v-if="meals.filter(m => m.breakfastExceptions && m.breakfastExceptions.length || m.lunchExceptions && m.lunchExceptions.length || m.dinnerExceptions && m.dinnerExceptions.length || m.incidentalsExceptions && m.incidentalsExceptions.length).length > 0">
                            <div class="list-group-item  list-group-item-danger">Warnings</div>
                            <div class="list-group-item ">
                                The meals listed below exceed per diem limits and must have been pre-arranged as part of a meeting or event to
                                be reimbursable expenses - supporting documentation required.
                            </div>
                            <div class="list-group-item ">
                                <div v-for="(m,mIndex) in meals">
                                    <!-- BREAKFAST -->
                                    <div v-for="(breakfastException, bExceptionIndex) in m.breakfastExceptions">
                                        <div v-if="breakfastException != null && breakfastException.expenseExceptionTypeId == 3">
                                            {{m.date | formatDate}} Breakfast per diem rate invalid
                                        </div>
                                        <div v-if="breakfastException != null && breakfastException.expenseExceptionTypeId == 4">
                                            {{m.date | formatDate}} Breakfast
                                        </div>
                                        <div v-if="breakfastException != null && breakfastException.expenseExceptionTypeId == 5">
                                            {{m.date | formatDate}} Breakfast: {{exceptions.find(x => x.expenseExceptionTypeId == 5).exceptionText}}
                                            <b-form-textarea id="textarea"
                                                             v-model="breakfastException.responseValue"
                                                             placeholder=""
                                                             rows="1"
                                                             max-rows="1">
                                            </b-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Lunch -->
                                    <div v-for="(lunchException, lExceptionIndex) in m.lunchExceptions">
                                        <div v-if="lunchException != null && lunchException.expenseExceptionTypeId == 3">
                                            {{m.date | formatDate}} Lunch per diem rate invalid
                                        </div>
                                        <div v-if="lunchException != null && lunchException.expenseExceptionTypeId == 4">
                                            {{m.date | formatDate}} Lunch
                                        </div>
                                        <div v-if="lunchException != null && lunchException.expenseExceptionTypeId == 5">
                                            {{m.date | formatDate}} Lunch: {{exceptions.find(x => x.expenseExceptionTypeId == 5).exceptionText}}
                                            <b-form-textarea id="textarea"
                                                             v-model="lunchException.responseValue"
                                                             placeholder=""
                                                             rows="1"
                                                             max-rows="1">
                                            </b-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Dinner -->
                                    <div v-for="(dinnerException, dExceptionIndex) in m.dinnerExceptions">
                                        <div v-if="dinnerException != null && dinnerException.expenseExceptionTypeId == 3">
                                            {{m.date | formatDate}} Dinner per diem rate invalid
                                        </div>
                                        <div v-if="dinnerException != null && dinnerException.expenseExceptionTypeId == 4">
                                            {{m.date | formatDate}} Dinner
                                        </div>
                                        <div v-if="dinnerException != null && dinnerException.expenseExceptionTypeId == 5">
                                            {{m.date | formatDate}} Dinner: {{exceptions.find(x => x.expenseExceptionTypeId == 5).exceptionText}}
                                            <b-form-textarea id="textarea"
                                                             v-model="dinnerException.responseValue"
                                                             placeholder=""
                                                             rows="1"
                                                             max-rows="1">
                                            </b-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Incidentals -->
                                    <div v-for="(incidentalsException, iExceptionIndex) in m.incidentalsExceptions">
                                        <div v-if="incidentalsException != null && incidentalsException.expenseExceptionTypeId == 3">
                                            {{m.date | formatDate}} Incidentals per diem rate invalid
                                        </div>
                                        <div v-if="incidentalsException != null && incidentalsException.expenseExceptionTypeId == 4">
                                            {{m.date | formatDate}} Incidentals
                                        </div>
                                        <div v-if="incidentalsException != null && incidentalsException.expenseExceptionTypeId == 5">
                                            {{m.date | formatDate}} Incidentals: {{exceptions.find(x => x.expenseExceptionTypeId == 5).exceptionText}}
                                            <b-form-textarea id="textarea"
                                                             v-model="incidentalsException.responseValue"
                                                             placeholder=""
                                                             rows="1"
                                                             max-rows="1">
                                            </b-form-textarea>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <button class="btn btn-secondary btn-sm margin-bottom" type="button" @click="$bvModal.show('exceptionAttachmentsModal')">Attach</button>
                                <div style="cursor: pointer">
                                    <div v-for="(baa,baaIndex) in attachments">
                                        <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.mealAttachment,baaIndex)">&times;</span>
                                    </div>
                                </div>
                                <div>Note - Non-reimbursable meal costs should be adjusted in the input table above.</div>
                                <b-modal id="exceptionAttachmentsModal" centered title="Add Attachment" :hide-footer=true>
                                    <AttachmentComponent :expenseReportId="expenseReportID" :attachments="attachments" @fileUploadDone="$bvModal.hide('exceptionAttachmentsModal')"></AttachmentComponent>
                                </b-modal>
                            </div>
                        </div>
                        <b-form-textarea id="supportingRemark"
                                         v-model="supportingRemark"
                                         placeholder="Supporting remarks, if needed"
                                         rows="1"
                                         max-rows="3"
                                         style="margin-bottom:15px;">
                        </b-form-textarea>
                        <button type="button" class="btn btn-primary btn-lg" @click="saveMeals()">Save</button>
                    </form>
                </div>
                <CommentsComponent v-if="!loading && expenseReportStatusTypeId > 1" :expenseReportID="expenseReportID" :area="'meals'"></CommentsComponent>
                <div v-if="!loading && expenseReportStatusTypeId > 1" class="col-md-12">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="expenseReportID" :area="'meals'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Save progress?" :is-small="true" v-if="show_modal" @close="show_modal=false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveAndContinue(true)">Save</button>
                <button type="button" class="btn btn-primary" @click="saveAndContinue(false)">Cancel</button>
            </div>
        </modal>
    </div>
</template>


<script>
    // @ is an alias to /src
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import MealService from '@/services/MealService'
    import DateService from '@/services/DateService'
    import TripProfileService from '@/services/TripProfileService'
    import ValidationAlertComponent from '@/components/ValidationAlertComponent.vue'
    import modal from '@/components/modal.vue'

    export default {
        name: 'meals',
        components: {
            TravelExpenseReportTabs,
            AttachmentComponent,
            AuditHistoryComponent,
            CommentsComponent,
            ValidationAlertComponent,
            modal
        },
        async created() {
            //check if existing meals
            if (this.$route.params.erid) {
                this.expenseReportID = this.$route.params.erid;
                this.referenceDates = await MealService.getReferenceDates(this.expenseReportID);
                this.mealSummary = await MealService.getMealsLocationSummary(this.expenseReportID);
                let mealsResponse = await MealService.getMeals(this.expenseReportID);
                let response = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                this.expenseReportStatusTypeId = response.expenseReportStatusTypeId;
                this.expenseReportStatusTypeName = response.expenseReportStatusTypeName;
                if (!Array.isArray(mealsResponse.mealDates) || mealsResponse.mealDates.length == 0) {
                    this.createMeals();
                }
                else {
                    this.mapMealsToView(mealsResponse.mealDates)
                }

                this.meals.forEach(m => {
                    if (m.breakfastExceptions.length) {
                        if (m.breakfastExceptions[0].attachments) {
                            this.attachments = this.attachments.concat(m.breakfastExceptions[0].attachments);
                        }
                    }
                    if (m.lunchExceptions.length) {
                        if (m.lunchExceptions[0].attachments) {
                            this.attachments = this.attachments.concat(m.lunchExceptions[0].attachments);
                        }
                    }
                    if (m.dinnerExceptions.length) {
                        if (m.dinnerExceptions[0].attachments) {
                            this.attachments = this.attachments.concat(m.dinnerExceptions[0].attachments);
                        }
                    }
                    if (m.incidentalsExceptions.length) {
                        if (m.incidentalsExceptions[0].attachments) {
                            this.attachments = this.attachments.concat(m.incidentalsExceptions[0].attachments);
                        }
                    }
                });

                this.supportingRemark = mealsResponse.supportingRemark;
                this.loading = false;
                this.hash = this.hashData;
            }
        },
        data: function () {
            return {
                expenseReportStatusTypeId: 1,
                expenseReportStatusTypeName: "",
                loading: true,
                mealsToBeDeleted: [],
                prearrangedmeeting: false,
                mealSummary: null,
                expenseReportID: null,
                referenceDates: [],
                meals: [],
                supportingRemark: '',
                mealsGrandTotal: 0,
                exceptions: [
                    {
                        exceptionText: 'Actual cost exceeds allowable per diem. Was this meal pre-arranged as part of a meeting or event?',
                        exceptionType: 'radio',
                        expenseExceptionTypeId: 4,
                        lodgeExceptionTypes: [
                            {
                                text: 'yes',
                                value: true
                            },
                            {
                                text: 'no',
                                value: false
                            }
                        ]
                    },
                    {
                        exceptionText: "Because you charged expenses on a personal day, please provide an explanation.",
                        exceptionType: 'text',
                        expenseExceptionTypeId: 5,
                        lodgeExceptionTypes: []
                    },
                    {
                        exceptionText: "Per diem rate is not valid",
                        exceptionType: 'text',
                        expenseExceptionTypeId: 3,
                        lodgeExceptionTypes: []
                    }
                ],
                hash: null,
                show_modal: false,
                temp: true,
                outOfPocket: false,
                attachments: [],
                show_modal_remove: false,
                ItemRemoveType: {
                    mealAttachment: 0
                },
                auto_populated: false
            }
        },
        computed: {
            hashData: function () {
                return JSON.stringify(MealService.createSaveRequest(this.expenseReportID, this.meals, this.supportingRemark, this.attachments));
            }
        },
        methods: {
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.attachments.splice(index, 1)
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            async saveAndContinue(save) {
                let success = false;
                if (save) {
                    success = await this.saveMeals();
                    if (success) {
                        this.navNext();
                    } else {
                        this.navNext();
                    }
                }
                else {
                    this.navNext();
                    this.show_modal = false;
                }
            },
            mapAttachments() {

            },
            downloadFileInNewWindow(params) {
                console.log(params)
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            //placehodler for validation
            isValid() {
                //validation here
                return true;
            },
            updateMealAdjustments: function (mealday) {
                //await next tick as mealday is not updated yet
                this.$nextTick(() => {
                    this.updateMealDay(mealday);
                })
            },
            async saveMeals() {
                console.log('mealsview.methods.saveMeals')
                let isSuccess = false;
                if (this.isValid()) {

                    try {
                        let mealRequest = MealService.createSaveRequest(this.expenseReportID, this.meals, this.supportingRemark, this.attachments)
                        let mealResponse = await MealService.saveMeals(mealRequest)
                        console.log(mealResponse)
                        this.expenseReportID = mealResponse.expenseReportId;
                        this.meals.length = 0;
                        this.mapMealsToView(mealResponse.mealDates)
                        this.$refs.nav.getSummaryCosts();
                        this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Meals saved successfully" });
                        isSuccess = true;
                        window.scrollTo(0, 0);
                        this.hash = this.hashData;
                    } catch (e) {
                        this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                    }
                    console.log(isSuccess)
                    return isSuccess;
                }
            },
            autoPopulateAll: function () {
                let context = this;
                this.auto_populated = true;
                if (context.meals.length > 0) {
                    context.meals.forEach(mealDay => {

                        let rd = context.referenceDates.filter(function (l) {
                            let referenceDateFormatted = DateService.normalizeDateTime(l.date)
                            let mealDayFormatted = DateService.normalizeDateTime(mealDay.date)
                            return context.moment(referenceDateFormatted).isSame(mealDayFormatted, 'day');
                        })

                        mealDay.breakfast = rd[0].personal ? 0 : rd[0].referenceMeals[0].amount;
                        mealDay.lunch = rd[0].personal ? 0 : rd[0].referenceMeals[1].amount;
                        mealDay.dinner = rd[0].personal ? 0 : rd[0].referenceMeals[2].amount;
                        mealDay.incidentals = rd[0].personal ? 0 : rd[0].referenceMeals[3].amount;
                        context.updateMealDay(mealDay)
                    })
                }
            },
            zeroOutAll: function (meals) {
                if (meals.length > 0) {
                    meals.forEach(m => {
                        this.zeroOut(m);
                    })
                }
            },
            //set a day of meals values to 0
            zeroOut: function (mealDay) {
                mealDay.breakfast = 0;
                mealDay.lunch = 0;
                mealDay.dinner = 0;
                mealDay.incidentals = 0;
                mealDay.total = 0;
                mealDay.breakfastFirstOrLastDayAdjustment = 0;
                mealDay.breakfastOverThreeTimesAdjustment = 0;
                mealDay.lunchFirstOrLastDayAdjustment = 0;
                mealDay.lunchOverThreeTimesAdjustment = 0;
                mealDay.dinnerFirstOrLastDayAdjustment = 0;
                mealDay.dinnerOverThreeTimesAdjustment = 0;
                mealDay.incidentalsFirstOrLastDayAdjustment = 0;
                mealDay.incidentalsOverThreeTimesAdjustment = 0;
                mealDay.adjustedTotal = 0;
                this.updateMealDay(mealDay);
                mealDay.breakfastExceptions = [];
                mealDay.lunchExceptions = [];
                mealDay.dinnerExceptions = [];
                mealDay.incidentalsExceptions = []
                //this.calculateHotelDaysTotals(hotel);
                //this.calculateWarnings(hotel, hdd);
            },
            //calculate warnings for a given day of meals
            async calculateWarnings(mealDay) {
                let context = this;

                let referenceDay = this.referenceDates.filter(function (l) {
                    //console.log(l.date)
                    //console.log('meal day')
                    //console.log(mealDay.date)

                    let referenceDateFormatted = DateService.normalizeDateTime(l.date)
                    let mealDayFormatted = DateService.normalizeDateTime(mealDay.date)

                    //console.log(referenceDateFormatted)
                    //console.log(mealDayFormatted)


                    return context.moment(referenceDateFormatted).isSame(mealDayFormatted, 'day');
                })

                let exceptionIdsToDelete = [];
                if (!mealDay.breakfastExceptions) {
                    mealDay.breakfastExceptions = [];
                }

                console.log(mealDay.breakfastExceptions);
                //check if personal day and any value over zero for breakfast
                exceptionIdsToDelete.push(this.setExceptions(mealDay.breakfastExceptions, 5, mealDay.breakfast > 0 && mealDay.personalDay));

                // if per diem rate is 0
                exceptionIdsToDelete.push(this.setExceptions(mealDay.breakfastExceptions, 3, referenceDay[0].referenceMeals[0].amount == 0 && referenceDay[0].referenceMeals[0].amount < mealDay.breakfast));

                // if breakfast meal is greater then reference amount
                exceptionIdsToDelete.push(this.setExceptions(mealDay.breakfastExceptions, 4, referenceDay[0].referenceMeals[0].amount < mealDay.breakfast));
                console.log(mealDay.breakfastExceptions);

                if (!mealDay.lunchExceptions) {
                    mealDay.lunchExceptions = [];
                }

                //check if personal day and any value over zero for lunch
                exceptionIdsToDelete.push(this.setExceptions(mealDay.lunchExceptions, 5, mealDay.lunch > 0 && mealDay.personalDay));

                // if per diem rate is 0
                exceptionIdsToDelete.push(this.setExceptions(mealDay.lunchExceptions, 3, referenceDay[0].referenceMeals[1].amount == 0 && referenceDay[0].referenceMeals[1].amount < mealDay.lunch));

                //check if lunch over ammount
                exceptionIdsToDelete.push(this.setExceptions(mealDay.lunchExceptions, 4, referenceDay[0].referenceMeals[1].amount < mealDay.lunch));

                if (!mealDay.dinnerExceptions) {
                    mealDay.dinnerExceptions = [];
                }

                //check if personal day and any value over zero for dinner
                exceptionIdsToDelete.push(this.setExceptions(mealDay.dinnerExceptions, 5, mealDay.dinner > 0 && mealDay.personalDay));
                // if per diem rate is 0
                exceptionIdsToDelete.push(this.setExceptions(mealDay.dinnerExceptions, 3, referenceDay[0].referenceMeals[2].amount == 0 && referenceDay[0].referenceMeals[2].amount < mealDay.dinner));
                //check if dinner over ammount
                exceptionIdsToDelete.push(this.setExceptions(mealDay.dinnerExceptions, 4, referenceDay[0].referenceMeals[2].amount < mealDay.dinner));

                if (!mealDay.incidentalsExceptions) {
                    mealDay.incidentalsExceptions = [];
                }

                //check if personal day and any value over zero for incidentals
                exceptionIdsToDelete.push(this.setExceptions(mealDay.incidentalsExceptions, 5, mealDay.incidentals > 0 && mealDay.personalDay));

                // if per diem rate is 0
                exceptionIdsToDelete.push(this.setExceptions(mealDay.incidentalsExceptions, 3, referenceDay[0].referenceMeals[3].amount == 0 && referenceDay[0].referenceMeals[3].amount < mealDay.incidentals));

                //check if incidentals over ammount
                exceptionIdsToDelete.push(this.setExceptions(mealDay.incidentalsExceptions, 4, referenceDay[0].referenceMeals[3].amount < mealDay.incidentals));

                for (let i = 0; i < exceptionIdsToDelete.length; i++) {
                    if (exceptionIdsToDelete[i]) {
                        await MealService.deleteException(exceptionIdsToDelete[i]);
                    }
                }

                ////check if personal day
                //if ((Array.isArray(referenceDay) && referenceDay.length) && referenceDay[0].personal == true) {
                //    hotelDay.personalDay = true;
                //}

            },
            //resets a day of meals to day reference values
            resetMealDayToReferenceValues: function (mealDay) {
                //let referenceDay = this.referenceDates.filter(l => this.moment(this.moment.utc(l.date).format('MM-DD-YYYY')).isSame(mealDay.date))

                let context = this;
                let referenceDay = this.referenceDates.filter(function (l) {
                    let referenceDateFormatted = DateService.normalizeDateTime(l.date)
                    let mealDayFormatted = DateService.normalizeDateTime(mealDay.date)

                    return context.moment(referenceDateFormatted).isSame(mealDayFormatted, 'day');
                })

                mealDay.breakfastFirstOrLastDayAdjustment = 0;
                mealDay.breakfastOverThreeTimesAdjustment = 0;
                mealDay.lunchFirstOrLastDayAdjustment = 0;
                mealDay.lunchOverThreeTimesAdjustment = 0;
                mealDay.dinnerFirstOrLastDayAdjustment = 0;
                mealDay.dinnerOverThreeTimesAdjustment = 0;
                mealDay.incidentalsFirstOrLastDayAdjustment = 0;
                mealDay.incidentalsOverThreeTimesAdjustment = 0;
                mealDay.breakfast = referenceDay[0].personal ? 0 : referenceDay[0].referenceMeals[0].amount;
                mealDay.lunch = referenceDay[0].personal ? 0 : referenceDay[0].referenceMeals[1].amount;
                mealDay.dinner = referenceDay[0].personal ? 0 : referenceDay[0].referenceMeals[2].amount;
                mealDay.incidentals = referenceDay[0].personal ? 0 : referenceDay[0].referenceMeals[3].amount;
                this.updateMealDay(mealDay)
            },
            //calculate meal day total
            updateMealDay: function (day) {
                if (!day.breakfast || isNaN(day.breakfast) || day.breakfast < 0) {
                    day.breakfast = 0;
                }

                if (!day.lunch || isNaN(day.lunch) || day.lunch < 0) {
                    day.lunch = 0;
                }

                if (!day.dinner || isNaN(day.dinner) || day.dinner < 0) {
                    day.dinner = 0;
                }

                if (!day.incidentals || isNaN(day.incidentals) || day.incidentals < 0) {
                    day.incidentals = 0;
                }
                
                this.calculateDayTotal(day)
                this.calculateWarnings(day)
            },
            ensureMaxIsNot3TimesReferenceValue: function (day) {
                console.log('mealView.methods.ensureMaxIsNot3TimesReferenceValue')
                let context = this;
                let referenceDay = this.referenceDates.filter(function (l) {
                    let referenceDateFormatted = DateService.normalizeDateTime(l.date)
                    let mealDayFormatted = DateService.normalizeDateTime(day.date)
                    return context.moment(referenceDateFormatted).isSame(mealDayFormatted, 'day');
                })

                //BREAKFAST
                //if exception response value is false adjust down to 100 percent max.
                if (day.breakfastExceptions && day.breakfastExceptions.length > 0) {
                    {
                        if (day.breakfast > 3 * referenceDay[0].referenceMeals[0].amount) {
                            day.breakfastOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[0].amount) - day.breakfast;
                        }
                        else {
                            day.breakfastOverThreeTimesAdjustment = 0;
                        }
                    }
                }
                else {
                    //exception does not exist and breakfast value is greater than 300% of reference. Set adjustment to anything above and beyond 300%.
                    if (day.breakfast > 3 * referenceDay[0].referenceMeals[0].amount) {
                        day.breakfastOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[0].amount) - day.breakfast;
                    }
                    else {
                        day.breakfastOverThreeTimesAdjustment = 0;
                    }
                }

                //LUNCH
                if (day.lunchExceptions && day.lunchExceptions.length > 0) {
                    if (day.lunchExceptions[0].responseValue.length) {
                        if (day.lunch > 3 * referenceDay[0].referenceMeals[1].amount) {
                            day.lunchOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[1].amount) - day.lunch;
                        }
                        else {
                            day.lunchOverThreeTimesAdjustment = 0;
                        }
                    }
                }
                else {
                    //exception does not exist and breakfast value is greater than 300% of reference. Set adjustment to anything above and beyond 300%.
                    if (day.lunch > 3 * referenceDay[0].referenceMeals[1].amount) {
                        day.lunchOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[1].amount) - day.lunch;
                    }
                    else {
                        day.lunchOverThreeTimesAdjustment = 0;
                    }
                }

                //DINNER
                //if exception response value is false adjust down to 100 percent max.
                if (day.dinnerExceptions && day.dinnerExceptions.length > 0) {
                    if (day.dinner > 3 * referenceDay[0].referenceMeals[2].amount) {
                        day.dinnerOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[2].amount) - day.dinner;
                    }
                    else {
                        day.dinnerOverThreeTimesAdjustment = 0;
                    }
                }
                else {
                    //exception does not exist and dinner value is greater than 300% of reference. Set adjustment to anything above and beyond 300%.
                    if (day.dinner > 3 * referenceDay[0].referenceMeals[2].amount) {
                        day.dinnerOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[2].amount) - day.dinner;
                    }
                    else {
                        day.dinnerOverThreeTimesAdjustment = 0;
                    }
                }

                //INCIDENTALS
                //if exception response value is false adjust down to 100 percent max.
                if (day.incidentalsExceptions && day.incidentalsExceptions.length > 0) {
                    if (day.incidentals > 3 * referenceDay[0].referenceMeals[3].amount) {
                        day.incidentalsOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[3].amount) - day.incidentals;
                    }
                    else {
                        day.incidentalsOverThreeTimesAdjustment = 0;
                    }
                }
                else {
                    //exception does not exist and incidentals value is greater than 300% of reference. Set adjustment to anything above and beyond 300%.
                    if (day.incidentals > 3 * referenceDay[0].referenceMeals[0].amount) {
                        day.incidentalsOverThreeTimesAdjustment = (3 * referenceDay[0].referenceMeals[0].amount) - day.incidentals;
                    }
                    else {
                        day.incidentalsOverThreeTimesAdjustment = 0;
                    }
                }
            },
            calculateFirstAndLastDayMealValues: function (day) {
                //get reference day
                let context = this;
                let referenceDay = this.referenceDates.filter(l => context.moment(DateService.normalizeDateTime(l.date)).isSame(day.date, 'day'));
                let isMealsPristine = true;

                //check if all meals match
                //calculate -25% for first and last day as they are travel day
                if (day.firstOrLastDay) {
                    if (day.breakfast > 0 && isMealsPristine) {
                        day.breakfastFirstOrLastDayAdjustment = -.25 * (Number(day.breakfastOverThreeTimesAdjustment) + Number(day.breakfast));
                    } else {
                        day.breakfastFirstOrLastDayAdjustment = 0;
                    }
                    if (day.lunch > 0 && isMealsPristine) {
                        day.lunchFirstOrLastDayAdjustment = -.25 * (Number(day.lunchOverThreeTimesAdjustment) + Number(day.lunch));
                    }
                    else {
                        day.lunchFirstOrLastDayAdjustment = 0;
                    }
                    if (day.dinner > 0 && isMealsPristine) {
                        day.dinnerFirstOrLastDayAdjustment = -.25 * (Number(day.dinnerOverThreeTimesAdjustment) + Number(day.dinner));
                    }
                    else {
                        day.dinnerFirstOrLastDayAdjustment = 0;
                    }
                    if (day.incidentals > 0 && isMealsPristine) {
                        day.incidentalsFirstOrLastDayAdjustment = -.25 * (Number(day.incidentalsOverThreeTimesAdjustment) + Number(day.incidentals));
                    }
                    else {
                        day.incidentalsFirstOrLastDayAdjustment = 0;
                    }
                }

            },
            calculateDayTotal: function (day) {
                //value cannot be more then 300% per meal, adjustment should be created for additional overage
                this.ensureMaxIsNot3TimesReferenceValue(day)
                this.calculateFirstAndLastDayMealValues(day)

                //calculate total
                day.total = Number(day.breakfast) + Number(day.lunch) + Number(day.dinner) + Number(day.incidentals)

                //adjusted total = adding all all adjustments
                console.log('adjusting breakfast')
                console.log(day.breakfastFirstOrLastDayAdjustment)
                day.breakfastAdjusted = day.breakfastFirstOrLastDayAdjustment + day.breakfastOverThreeTimesAdjustment;//add more adjustments here. like breakfastfirstday + another exception etc;
                day.lunchAdjusted = day.lunchFirstOrLastDayAdjustment + day.lunchOverThreeTimesAdjustment;
                day.dinnerAdjusted = day.dinnerFirstOrLastDayAdjustment + day.dinnerOverThreeTimesAdjustment;
                day.incidentalsAdjusted = day.incidentalsFirstOrLastDayAdjustment + day.incidentalsOverThreeTimesAdjustment;

                day.adjustedTotal = (Number(day.breakfast) + Number(day.breakfastAdjusted)) + (Number(day.lunch) + Number(day.lunchAdjusted)) + (Number(day.dinner) + Number(day.dinnerAdjusted)) + (Number(day.incidentals) + Number(day.incidentalsAdjusted))
                //recalculate totals
                //this.calculateHotelDaysTotals(hotel);
                this.calculateMealsGrandTotel();
            },
            calculateMealsGrandTotel() {
                let grandTotal = 0;
                this.meals.forEach(m => {
                    console.log(m.adjustedTotal)
                    grandTotal = Number(grandTotal) + Number(m.adjustedTotal)
                })
                this.mealsGrandTotal = grandTotal;
            },
            //When no meal days are saved to report this method is called to create initial days and populate reference values.
            createMeals: function () {

                this.referenceDates.forEach(rd =>
                    this.meals.push(
                        {
                            date: DateService.normalizeDateTime(rd.date),
                            breakfast: 0,
                            breakfastAdjusted: 0,
                            breakfastFirstOrLastDayAdjustment: 0,
                            breakfastOverThreeTimesAdjustment: 0,
                            breakfastExceptions: [],
                            lunch: 0,
                            lunchFirstOrLastDayAdjustment: 0,
                            lunchOverThreeTimesAdjustment: 0,
                            lunchExceptions: [],
                            lunchAdjusted: 0,
                            dinner: 0,
                            dinnerExceptions: [],
                            dinnerFirstOrLastDayAdjustment: 0,
                            dinnerOverThreeTimesAdjustment: 0,
                            dinnerAdjusted: 0,
                            exceptions: [],
                            incidentals: 0,
                            incidentalsExceptions: [],
                            incidentalsFirstOrLastDayAdjustment: 0,
                            incidentalsOverThreeTimesAdjustment: 0,
                            incidentalsAdjusted: 0,
                            total: 0,
                            adjustedTotal: 0,
                            personalDay: rd.personal,
                            firstOrLastDay: false
                        }
                    ))

                //set bool flag for first or last day used for per diem calculations
                let m = this.moment;
                const oldestDate = this.meals.reduce(function (prev, current) {

                    if (current.personalDay) {
                        return prev;
                    }
                    let prevDate = DateService.normalizeDateTime(prev.date)
                    let currentDate = DateService.normalizeDateTime(current.date)

                    return (m(prevDate).isAfter(currentDate, 'day')) ? prev : current
                }) //returns obj
                oldestDate.firstOrLastDay = true;

                const firstDate = this.meals.reduce(function (prev, current) {

                    if (prev.personalDay) {
                        return current;
                    }
                    let prevDate = DateService.normalizeDateTime(prev.date)
                    let currentDate = DateService.normalizeDateTime(current.date)

                    return (m(prevDate).isBefore(currentDate, 'day')) ? prev : current
                }) //returns obj
                firstDate.firstOrLastDay = true;

                this.meals.forEach(md => this.updateMealDay(md));
            },
            async mapMealsToView(exisitingMeals) {
                console.log('inside mapMealsToView')
                console.log('exisitingMeals')
                console.log(exisitingMeals)
                let context = this;
                exisitingMeals.forEach(async (eM) => {

                    let referenceDay = this.referenceDates.filter(l => context.moment(DateService.normalizeDateTime(l.date)).isSame(eM.date, 'day'));

                    console.log('reference day')
                    console.log(referenceDay)

                    //console.log('before reference day')
                    //let referenceDay = this.referenceDates.filter(function (l) {
                    //    console.log('before referenceDateFormatted')
                    //    console.log(l.date)
                    //    let referenceDateFormatted = context.moment.utc(l.date).format('ddd, DD MMM YYYY HH:mm:ss ZZ');
                    //    console.log('before mealDayFormatted')
                    //    console.log(eM.date)
                    //    let mealDayFormatted = context.moment.utc(eM.date, 'MM-DD-YYYY').format('ddd, DD MMM YYYY HH:mm:ss ZZ');

                    //    return context.moment(referenceDateFormatted).isSame(mealDayFormatted, 'day');
                    //})

                    console.log('outside reference day')
                    if (referenceDay[0]) {

                        console.log('inside reference day')
                        console.log(referenceDay[0])
                        //order by asc as below mapping depends on order of meals array items
                        eM.meals = _.orderBy(eM.meals, 'id', 'asc')

                        let m = {
                            date: DateService.normalizeDateTime(eM.date),
                            dayDateID: eM.id,
                            breakfast: eM.meals[0].amount,
                            breakfastAdjusted: eM.meals[0].adjustment,
                            breakfastFirstOrLastDayAdjustment: 0,
                            breakfastOverThreeTimesAdjustment: 0,
                            breakfastID: eM.meals[0].id,
                            breakfastExceptions: eM.meals[0].exceptions || [],//for now
                            lunch: eM.meals[1].amount,
                            lunchAdjusted: eM.meals[1].adjustment,
                            lunchFirstOrLastDayAdjustment: 0,
                            lunchOverThreeTimesAdjustment: 0,
                            lunchID: eM.meals[1].id,
                            lunchExceptions: eM.meals[1].exceptions || [],//for now
                            dinner: eM.meals[2].amount,
                            dinnerAdjusted: eM.meals[2].adjustment,
                            dinnerFirstOrLastDayAdjustment: 0,
                            dinnerOverThreeTimesAdjustment: 0,
                            dinnerID: eM.meals[2].id,
                            dinnerExceptions: eM.meals[2].exceptions || [],//for now
                            incidentals: eM.meals[3].amount,
                            incidentalsAdjusted: eM.meals[3].adjustment,
                            incidentalsOverThreeTimesAdjustment: 0,
                            incidentalsFirstOrLastDayAdjustment: 0,
                            incidentalsID: eM.meals[3].id,
                            incidentalsExceptions: eM.meals[3].exceptions || [],//for now
                            total: 0,//for now
                            adjustedTotal: 0,//for now
                            personalDay: false, //gets set when comparing to reference days
                            firstOrLastDay: false
                        }

                        m.personalDay = referenceDay[0].personal
                        console.log('pushing meal')
                        console.log(m)
                        this.meals.push(m);
                    }
                    else {
                        //add to list of meals to be deleted as they are no longer valid.
                        //this.mealsToBeDeleted.push(eM.id)
                        console.log('calling delete')
                        await this.deleteMeal(eM.id);
                    }
                })

                //let context = this;
                //account for changing date in trip profile.
                this.referenceDates.forEach(rd => {
                    console.log('yo')
                    //console.log(l.date)
                    console.log(rd.date)
                    console.log(exisitingMeals[0].date)

                    //let existingMeal = exisitingMeals.filter(l => this.moment(l.date).isSame(this.moment(rd.date), 'day'));


                    console.log(exisitingMeals)
                    let existingMeal = exisitingMeals.filter(function (eM) {
                        let mealDayFormatted = DateService.normalizeDateTime(eM.date)//context.moment.utc(eM.date).format('ddd, DD MMM YYYY HH:mm:ss ZZ');
                        let referenceDateFormatted = DateService.normalizeDateTime(rd.date)//context.moment.utc(rd.date).format('ddd, DD MMM YYYY HH:mm:ss ZZ');
                        return context.moment(mealDayFormatted).isSame(referenceDateFormatted, 'day');
                    })

                    if (existingMeal.length == 0) {
                        let m = {
                            date: DateService.normalizeDateTime(rd.date),
                            breakfast: rd.personal ? 0 : rd.referenceMeals[0].amount,
                            breakfastAdjusted: 0,
                            breakfastFirstOrLastDayAdjustment: 0,
                            breakfastOverThreeTimesAdjustment: 0,
                            breakfastExceptions: [],
                            lunch: rd.personal ? 0 : rd.referenceMeals[1].amount,
                            lunchExceptions: [],
                            lunchAdjusted: 0,
                            lunchFirstOrLastDayAdjustment: 0,
                            lunchOverThreeTimesAdjustment: 0,
                            dinner: rd.personal ? 0 : rd.referenceMeals[2].amount,
                            dinnerExceptions: [],
                            dinnerAdjusted: 0,
                            dinnerFirstOrLastDayAdjustment: 0,
                            dinnerOverThreeTimesAdjustment: 0,
                            exceptions: [],
                            incidentals: rd.personal ? 0 : rd.referenceMeals[3].amount,
                            incidentalsExceptions: [],
                            incidentalsAdjusted: 0,
                            incidentalsOverThreeTimesAdjustment: 0,
                            incidentalsFirstOrLastDayAdjustment: 0,
                            total: 0,
                            adjustedTotal: 0,
                            personalDay: rd.personal,
                            firstOrLastDay: false
                        }
                        this.meals.push(m)
                    }

                })
              
                ////set bool flag for first or last day used for per diem calculations
                let m = this.moment;
                const oldestDate = this.meals.reduce(function (prev, current) {

                    if (current.personalDay) {
                        return prev;
                    }
                    let prevDate = DateService.normalizeDateTime(prev.date)//m.utc(prev.date, 'MM-DD-YYYY').format('ddd, DD MMM YYYY HH:mm:ss ZZ');
                    let currentDate = DateService.normalizeDateTime(current.date)//m.utc(current.date, 'MM-DD-YYYY').format('ddd, DD MMM YYYY HH:mm:ss ZZ');

                    return (m(prevDate).isAfter(currentDate, 'day')) ? prev : current
                }) //returns obj
                oldestDate.firstOrLastDay = true;

                const firstDate = this.meals.reduce(function (prev, current) {

                    if (prev.personalDay) {
                        return current;
                    }
                    let prevDate = DateService.normalizeDateTime(prev.date)//m.utc(prev.date, 'MM-DD-YYYY').format('ddd, DD MMM YYYY HH:mm:ss ZZ');
                    let currentDate = DateService.normalizeDateTime(current.date) //m.utc(current.date, 'MM-DD-YYYY').format('ddd, DD MMM YYYY HH:mm:ss ZZ');

                    return (m(prevDate).isBefore(currentDate, 'day')) ? prev : current
                }) //returns obj
                firstDate.firstOrLastDay = true;

                this.meals.forEach(md => this.updateMealDay(md));

            },
            async deleteMeal(id) {
                await this.$http
                    .delete(`/Meals/${id}`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
            },
            async getMeals(erID) {
                await this.$http
                    .get(`expensereports/${erID}/Meals`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.supportingRemark = response.data.supportingRemark;


                    })
                //.catch(error => {
                //    this.$notify({
                //        group: 'errors',
                //        type: 'error',
                //        title: 'Error',
                //        text: error
                //    });
                //    this.errored = true
                //})
            },
            setExceptions(mealExceptions, expenseExceptionTypeId, needsException) {
                let exceptionTypeIndex = mealExceptions.findIndex((e) => e.expenseExceptionTypeId == expenseExceptionTypeId);
                if (needsException && !mealExceptions.length) {
                    if (exceptionTypeIndex < 0) {
                        let exception = {
                            expenseExceptionTypeId: expenseExceptionTypeId,
                            isSatisfied: false,
                            responseValue: '',
                            attachments: [],
                            id: null
                        }

                        mealExceptions.push(exception);
                    }
                }
                else if (exceptionTypeIndex >= 0 && !needsException) {

                    let idToDelete = mealExceptions[exceptionTypeIndex].id;
                    mealExceptions.splice(exceptionTypeIndex, 1);
                    return idToDelete;
                }

                return null;
            }
        },
        async beforeRouteLeave(to, from, next) {
            console.log('mealsview.method.beforeRouteLeave')
            if (this.expenseReportStatusTypeId > 1) {
                next()
            }
            else {
                this.navNext = next;

                if (this.$data.hash !== this.hashData) {
                    this.show_modal = true;
                }
                else {
                    console.log("Data has not changed");
                    next();
                }
            }
        }
    }

</script>

<style scoped>


    /*new styling from Maui 03/2020 */

    .table th, .table td {
        text-align: center;
        padding-left: 0;
    }


    input {
        text-align: center;
    }

    .td-updated {
        outline: 1px solid;
        padding-left: 0;
        padding-right: 0;
    }

    .personalText {
        display: none;
    }

    .showPersonalText {
        display: initial;
    }

    input.remove-input-border {
        width: 100%;
    }

    input:focus, textarea:focus, select:focus {
        outline: none;
    }


    /*Remove updown arrows on input */
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }


    /*end new styling*/


    .offday {
        background-color: #eeefe9;
    }

    .total {
        font-weight: bold;
    }

    .errortext {
        color: red;
        font-weight: 700;
    }

    .remove-input-border {
        border: none;
    }

    .margin-bottom {
        margin-bottom:10px;
    }
</style>